module.exports = __webpack_public_path__ + "1.4.15-unryo/img/couchbase.bb5e9f56.svg";